import { LegalEntities as Component } from './component';
import Connector from './connector';
import { ConnectorLegalEntitiesProps } from './LegalEntities.proptype';

export interface LegalEntitiesProps extends Omit<ConnectorLegalEntitiesProps, 'component'> {}

export const LegalEntities = (props: LegalEntitiesProps) => <Connector {...props} component={Component} />;
